import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";
import { contact } from "@/lib/site-data";

export function CtaBand() {
  return (
    <section className="bg-background py-12 md:py-16">
      <div className="container-artbaz">
        <Reveal className="relative overflow-hidden border border-border bg-charcoal px-8 py-16 text-charcoal-foreground md:px-14 md:py-20">
          <div className="absolute inset-x-0 top-0 h-1 bg-primary" />
          <div className="content-artbaz flex flex-col items-start gap-10 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-2xl">
              <span className="eyebrow">Spolupráca</span>
              <h2 className="mt-5 text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-[2.75rem]">
                Máte projekt, ktorý chcete zrealizovať?
              </h2>
              <p className="mt-5 max-w-xl text-base leading-relaxed text-charcoal-muted">
                Radi vám pomôžeme nájsť najlepšie riešenie. Kontaktujte nás a spoločne premeníme
                vaše predstavy na realitu.
              </p>
            </div>
            <div className="flex flex-col gap-4 sm:flex-row lg:flex-col xl:flex-row">
              <Button asChild variant="heroOutline" size="lg">
                <a href="/kontakt">
                  Cenová ponuka
                  <ArrowRight className="size-5" />
                </a>
              </Button>
              <Button asChild variant="hero" size="lg">
                <a href={`tel:${contact.phoneHref}`}>
                  <Phone className="size-5" />
                  Zavolajte nám
                </a>
              </Button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
